import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import { getCookieBannerClosed, renderHTML, setCookieBannerClosed } from '@/utils';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import {
  CloseButton,
  CloseButtonContainer,
  CookieBannerContainer,
  CookieBannerInnerContainer,
} from './CookieBanner.styles';

const CookieBanner: React.FC = () => {
  const [isClosed, setCloseState] = useState(false);
  const { t } = useGlobalState();

  const closeCookieBanner = () => {
    setCookieBannerClosed();
    if (getCookieBannerClosed()) setCloseState(true);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      closeCookieBanner();
    }
  };

  const cookieBannerText = () => {
    let cookieBanner = t(MasterTranslation.CookieBanner);

    cookieBanner = cookieBanner
      .replace(/\r?\n/g, '<br />')
      .replace(/{{(.*?)}}/g, '<a target="_blank" href="/privacy" rel="noreferrer">$1</a>');
    return renderHTML(cookieBanner);
  };

  useEffect(() => {
    if ((window as any).clarity && !Cookies.get('_clck')) {
      (window as any).clarity('consent');
    }
  }, []);

  if (isClosed) return null;

  return (
    <CookieBannerContainer>
      <CookieBannerInnerContainer>
        <div>{cookieBannerText()}</div>
        <CloseButtonContainer
          onClick={closeCookieBanner}
          onKeyDown={handleKeyDown}
          tabIndex={0}
          role='button'
          aria-label='Close cookie banner'
        >
          <CloseButton />
        </CloseButtonContainer>
      </CookieBannerInnerContainer>
    </CookieBannerContainer>
  );
};

export default CookieBanner;
